import React, { FC, useEffect } from 'react'
import { useHistory } from 'react-router'
import { fixedAssets } from 'src/containers/PreCache'
import { CurrentUserType } from 'src/ducks/auth'
import config from '../../config'
import Amplitude from '../../utils/amplitudeHelper'
import { StyledLobby } from './styled'

export const LobbyPage: FC<{ currentUser: CurrentUserType }> = ({ currentUser }) => {
  const history = useHistory()

  useEffect(() => {
    document.title = `${config.eventName} | Home`
  }, [])

  useEffect(() => {
    Amplitude.visit('Home')
  }, [currentUser.id])

  const goBooth = (id) => {
    history.push(`/booths/${id}`)
  }
  return (
    <>
      <StyledLobby>
        <img src={fixedAssets.rotateCircle} alt="event-visual" id="circle" className="visual mobile-hide" />
        
        <img width="100%" src={fixedAssets.kvTitle} alt="event-banner" className="titleImage d-none d-md-block mx-auto" />
        <img width="100%" src={fixedAssets.kvTitleM} alt="event-banner" className="titleImage d-md-none d-block mx-auto" />
        
        <img src={fixedAssets.growthBright} alt="event-visual" onClick={() => goBooth(1)} id="growth" className="visual mobile-hide" />
        <img src={fixedAssets.cognitionBright} alt="event-visual" onClick={() => goBooth(35)} id="cognition" className="visual mobile-hide" />
        <img src={fixedAssets.comfortBright} alt="event-visual" onClick={() => goBooth(2)} id="comfort" className="visual mobile-hide" />
        
       
        {/* <div id="current-user">Logged in as {currentUser.email}</div> */}
      </StyledLobby>
    </>
  )
}
